module.exports = __webpack_public_path__ + "img/DSC04039.d0b000c3.jpg";